import { HouseholdStructureType } from '@/types/schema.generated'

const householdStructureTypes: Record<
  ValueOf<typeof HouseholdStructureType>,
  string
> = {
  RETIRED: '定年後世帯',
  COUPLE_WITH_CHILDREN: '子あり夫婦世帯',
  COUPLE_WITHOUT_CHILDREN: '子なし夫婦世帯',
  SINGLE_WITH_CHILDREN: 'ひとり親世帯',
  ONE_PERSON: '単身世帯',
  UNSPECIFIED: '',
}

export const householdStructureTypeLabel = (value: HouseholdStructureType) =>
  householdStructureTypes[value]
